import containParts from 'utilities/validateStringParts';

const validate = (regex, value) => !!regex.test(value);

export const VALIDATORS = {
  number: value => validate(/\d/, value),
  symbol: value => validate(/[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/, value),
  lowercase: value => validate(/[a-z]/, value),
  uppercase: value => validate(/[A-Z]/, value),
  length: size => value => value.length >= size,
  contains: (...args) => value => !containParts([...args], value),
};

export default (validators, value) => {
  if (validators.length === 0) {
    return true;
  }
  return validators.every(validator => validator(value));
};
